import * as React from "react";
import * as ReactDOM from "react-dom";
import { renderReactComponent } from "~/sharedComponents/errorBoundary/renderReact";
import { noneOption } from "~/sharedComponents/list/const.ts";
import { DynamicPortfolioDropdown } from "../components/DynamicPortfolioDropdown";

/* eslint-disable */

(function ($) {
    $.widget('ep.portfolio_dropdown_record_field', $.ep.base_record_field, {
        options: {
            templateId: 'edit-record-portfolio-dropdown-template',
            /* { Id: number; Name: string; ParentId?: number; }[] */
            portfolios: [],
        },

        setDisabled: function () {
            // should not be called because this widget doesn't render deleted fields
        },

        getReactContainer: function () {
            return this.element[0].querySelector('.react-container');
        },

        afterRenderTemplate: function () {
            var _this = this;

            let reactElement = React.createElement(DynamicPortfolioDropdown, {
                value: this.value,
                emptyOption: { ...noneOption, label: this.options.resources.dropDownEmptyText },
                portfolios: this.options.portfolios,
                onChangeAction: value => {
                    _this.clearValidationResult();

                    let portfolio = _this.options.portfolios.find(x => x.Id == value);
                    _this._model.Values = !!portfolio ? [portfolio.Name] : [];
                },
            });

            renderReactComponent(reactElement, this.getReactContainer());

            this.setValidationRules();
        },

        setValidationRules: function () {
            let _this = this;
            this.ruleName = "portfolioDropDownNotNone_" + this._model.FieldID;

            if ($.validator.methods[this.ruleName] == undefined) {
                $.validator.addMethod(this.ruleName, function (value, element) {
                    return !!_this._model.Values.length && _this._model.Values.every(x => !!x);
                }, this.options.resources.validationRequired);
            }

            $(".error-container", this.element).rules("add", {
                [this.ruleName]: this.options.model.Required
            });
        },

        destroy: function () {
            delete $.validator.methods[this.ruleName];

            ReactDOM.unmountComponentAtNode(this.getReactContainer());

            // Call the base destroy function
            $.Widget.prototype.destroy.call(this);
        }
    });
})(jQuery);
/* eslint-enable */
